export const LiquidSniperAuctionV2Abi = [
  {
    type: "function",
    name: "nextAuctionBlock",
    inputs: [{ name: "poolId", type: "bytes32" }],
    outputs: [{ name: "nextAuctionBlock", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "round",
    inputs: [{ name: "poolId", type: "bytes32" }],
    outputs: [{ name: "round", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "gasPeg",
    inputs: [{ name: "poolId", type: "bytes32" }],
    outputs: [{ name: "gasPeg", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "feeConfig",
    inputs: [{ name: "poolId", type: "bytes32" }],
    outputs: [
      { name: "startingFee", type: "uint24" },
      { name: "endingFee", type: "uint24" },
      { name: "secondsToDecay", type: "uint256" },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "getFee",
    inputs: [{ name: "poolId", type: "bytes32" }],
    outputs: [{ name: "", type: "uint24" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "poolDecayStartTime",
    inputs: [{ name: "poolId", type: "bytes32" }],
    outputs: [{ name: "poolDecayStartTime", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "maxRounds",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "blocksBetweenAuction",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "blocksBetweenDeploymentAndFirstAuction",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "paymentPerGasUnit",
    inputs: [],
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
  },
] as const;
